import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { SetSelectedRecipient, SetSendMoneyCountryCurrency } from "../../actions/sendMoney";
import { ROUTES } from "../../constants/clientRoutes";
import { SendMoneyRecipientAccount, SendMoneyTransferMethodId } from "../../types/sendMoney";
import { SEND_MONEY_TRANSFER_METHOD_IDS } from "../../constants/enums";

// icons
import ChevronRight from "../../assets/images/icons/rebrand/chevron-right.svg";
import MobileWalletIcon from "../../assets/images/icons/mobile-wallet.svg";

const RecipientCard = ({ recipient, transferMethod }: { recipient: SendMoneyRecipientAccount, transferMethod: SendMoneyTransferMethodId }) => {
  const dispatch = useDispatch();
  const [primary, ...rest] = recipient.displayLines;
  let Icon: string | null = null;

  switch (transferMethod) {
    case SEND_MONEY_TRANSFER_METHOD_IDS.MOBILE_WALLET:
      Icon = MobileWalletIcon;
      break;
    default:
      Icon = MobileWalletIcon;
      break;
  }

  const onSelect = () => {
    dispatch(SetSelectedRecipient(recipient));
    // RecipientGetsRow reads country/currency for the flag and currency code
    dispatch(SetSendMoneyCountryCurrency({ country: recipient.countryIso, currency: recipient.currencyIso }));
  };

  return (
    <Link
      to={ROUTES.SEND_MONEY.TRANSFER_DETAILS}
      className="bwp-recipient-card"
      onClick={onSelect}
    >
      <div className="bwp-recipient-card__avatar">
        {Icon && <img src={Icon} alt="" />}
        <ReactCountryFlag className="emojiFlag flag" countryCode={recipient.countryIso} />
      </div>

      <div className="bwp-recipient-card__lines">
        <p className="bwp-recipient-card__name">{primary}</p>
        {rest.map((line, i) => (
          <p key={i} className="bwp-recipient-card__meta">{line}</p>
        ))}
      </div>

      <img src={ChevronRight} alt="" className="bwp-recipient-card__chevron" />
    </Link>
  );
};

export default RecipientCard;